import {Component, HostListener, OnDestroy} from '@angular/core';
import {Utils} from '../../utils.class';
import {Subscription} from 'rxjs';
import {Routenames} from '../../routenames';
import {LocalStorage} from '../../utils/storage';
import {Settings} from '../../settings/settings';
import {Reload} from '../../reload';
import {Features} from '../../services/auth/features';
import {Roles} from '../../services/auth/roles';
import {environment} from '../../../environments/environment';

@Component({template: ''})
export class CodaltComponent implements OnDestroy {

    Features = Features;
    Routenames = Routenames;
    Roles = Roles;
    Utils = Utils;
    LocalStorage = LocalStorage;
    Settings = Settings;
    window: Element;
    subscriptions = new Subscription();
    origin = '';
    env = environment;

    constructor() {
        if (typeof window !== 'undefined') {
            this.origin = Settings.IS_APP ? 'https://app.tsned.nl' : window.location.origin;
        }
        setTimeout(() => {
            this.setScrollParent();
        });
        this.subscriptions.add(Reload.doReload.subscribe(() => {

        }));
    }


    @HostListener('window:resize')
    setScrollParent() {
        if (typeof window !== 'undefined') {
            if (window?.innerWidth < 768 || Settings.IS_APP) {
                this.window = window?.document.querySelector('.main');
            } else {
                this.window = window?.document.querySelector('.mat-sidenav-content');
            }
        }
    }

    handleEscape(e?: KeyboardEvent) {
        return true;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
